var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10 0 1 1h-.002l2.001 2.005V3L14 4V.976 5h2v1.999L18 7v15H4v-2H2v-2h-.993A1 1 0 0 1 0 17.007V.993A1 1 0 0 1 1.007 0zm7 7h-1v13H5v1h12zm-2-2h-1v12.007a1 1 0 0 1-1.007.993H3v1h12zm-5-4H1v16h12l-.001-12.989L10 4.025zM7 5.013V6c.898.041 1.298.213 2 .5l-.268 1C8.089 7.217 7.807 7.046 7 7v2.013l.167.05c.515.156.627.19.917.373q.478.3.697.71.219.411.219.999 0 .848-.646 1.425c-.43.385-.625.352-1.354.443V14H6v-.987c-.898-.04-1.298-.213-2-.5l.268-1c.643.283.925.455 1.732.5L5.999 10l-.166-.05c-.515-.156-.627-.19-.917-.372q-.478-.3-.697-.711T4 7.869q0-.847.646-1.426C5.076 6.058 5.271 6.091 6 6v-.987zm.001 5L7 11l-.001-.001L7 12.013c.542-.073 1-.256 1-1 0-.742-.425-.826-.999-1M6 7c-.542.073-1 .257-1 1s.425.827.999 1L6 8.013z"
  })));
});
const SvgNavBulkIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavBulkIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOCAyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xMCAwIDEgMWgtLjAwMmwyLjAwMSAyLjAwNVYzTDE0IDRWLjk3NiA1TDE2IDV2MS45OTlMMTggN3YxNUg0di0ySDJ2LTJoLS45OTNBMSAxIDAgMCAxIDAgMTcuMDA3Vi45OTNBMSAxIDAgMCAxIDEuMDA3IDBIMTB6bTcgN2gtMXYxM0g1djFoMTJWN3ptLTItMmgtMXYxMi4wMDdhMSAxIDAgMCAxLTEuMDA3Ljk5M0gzdjFoMTJWNXptLTUtNEgxdjE2aDEybC0uMDAxLTEyLjk4OUwxMCA0LjAyNVYxek03IDUuMDEzVjZjLjg5OC4wNDEgMS4yOTguMjEzIDIgLjVsLS4yNjggMUM4LjA4OSA3LjIxNyA3LjgwNyA3LjA0NiA3IDd2Mi4wMTNsLjE2Ny4wNWMuNTE1LjE1Ni42MjcuMTkuOTE3LjM3My4zMTkuMi41NTEuNDM3LjY5Ny43MS4xNDYuMjc0LjIxOS42MDcuMjE5Ljk5OSAwIC41NjUtLjIxNSAxLjA0LS42NDYgMS40MjUtLjQzLjM4NS0uNjI1LjM1Mi0xLjM1NC40NDNWMTRINnYtLjk4N2MtLjg5OC0uMDQtMS4yOTgtLjIxMy0yLS41bC4yNjgtMWMuNjQzLjI4My45MjUuNDU1IDEuNzMyLjVMNS45OTkgMTBsLS4xNjYtLjA1Yy0uNTE1LS4xNTYtLjYyNy0uMTktLjkxNy0uMzcyLS4zMTktLjItLjU1MS0uNDM4LS42OTctLjcxMUM0LjA3MyA4LjU5MyA0IDguMjYgNCA3Ljg2OWMwLS41NjUuMjE1LTEuMDQuNjQ2LTEuNDI2LjQzLS4zODUuNjI1LS4zNTIgMS4zNTQtLjQ0M3YtLjk4N2gxem0uMDAxIDVMNyAxMWwtLjAwMS0uMDAxTDcgMTIuMDEzYy41NDItLjA3MyAxLS4yNTYgMS0xIDAtLjc0Mi0uNDI1LS44MjYtLjk5OS0xek02IDdjLS41NDIuMDczLTEgLjI1Ny0xIDFzLjQyNS44MjcuOTk5IDFMNiA4LjAxM1Y3eiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";